import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'calc(100% - 48px)',
  },
}))

const PAGES = [{
  title: 'Details',
  key: 'details',
},{
  title: 'Tasks',
  key: 'folder.tasks',
  withFolder: true,
},{
  title: 'Materials',
  key: 'materials',
},{
  title: 'Hire',
  key: 'hire',
},{
  title: 'Notes',
  key: 'notes',
}]

const PAGE_KEYS = PAGES.map(page => page.key)

const QuoteEdit = ({
  children,
}) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const id = useSelector(selectors.router.idParam)
  const route = useSelector(selectors.router.route)
  const queryParams = useSelector(selectors.router.params)
  const page = route.name.replace('quote.edit.', '')
  const folderid = queryParams.folderid || 'root'

  const onViewPage = (id, page, folderid) => {
    const params = {id}
    if(page.withFolder) params.folderid = folderid
    dispatch(routerActions.navigateTo(`quote.edit.${page.key}`, params))
  }
 
  const clickTab = (event, index) => {
    const page = PAGES[index]
    onViewPage(id, page, folderid)
  }

  const currentPageIndex = PAGE_KEYS.indexOf(page)

  return (
    <div className={ classes.root }>
      <AppBar position="static" color="default">
        <Tabs 
          value={ currentPageIndex } 
          onChange={ clickTab }
          indicatorColor="primary"
          textColor="primary"
        >
          {
            PAGES.map((page, i) => (
              <Tab key={ i } label={ page.title } />
            ))
          }
        </Tabs>
      </AppBar>
      { children }
    </div>
  )
}

export default QuoteEdit